export default function () {
	let modules = require.context('./', true, /\.js$/);
	modules.keys().map(module => {
		modules(module);
	});
}
